/**
 * @author HungNS
 */
import BaseService from "./BaseService";
import {ROOT, DASHBOARD, BALANCE} from "./_base";

class DashboardService extends BaseService {

    async getBanlanceInfo(params = {}) {
        const response = await this.get(`${ROOT}/${BALANCE}/get-balance-info`, params);
        return response.data
    }

    async getCustomerNews(params = {}) {
        const response = await this.get(`${ROOT}/${DASHBOARD}/customer-news`, params);
        return response.data
    }

    async getServerTime(params = {}) {
        const response = await this.get(`${ROOT}/${DASHBOARD}/get-server-time`, params);
        return response.data
    }

    async agreeNews(params = {}){
        const response = await this.post(`${ROOT}/${DASHBOARD}/agree-news`, params);
        return response.data;
    }

    async saveAgreementNews(params = {}){
        const response = await this.get(`${ROOT}/${DASHBOARD}/save-agree`, params);
        return response.data;
    }

}
export default DashboardService;
